import { local } from "wix-storage-frontend";
import wixWindowFrontend from "wix-window-frontend";

/**
 * Configuration to the LightBox logic
 */
//Lightbox to be displayed
const lightboxName = "event notification"; 

//Change this if you dont want to trigger the lightbox logic
const isEnabled = true;

// Update this if you want to show user the lightbox irrespective of the 7 days gap.
const currentSiteVersion = "2025-01-22";

//number of days the lightbox wont appear
const timeinMs =  1 * 60 * 60 * 1000; // Currently set to 1 hour
const secondsToWaitForLightBoxOnPageInMs = 5000;

/**
 * Dont change below logic !!!
 */
async function handleLightbox() {
    const storageKey = "lightboxData";
    
	// console.log("Custom Logic Check")
    await new Promise(resolve => setTimeout(resolve, secondsToWaitForLightBoxOnPageInMs));

    // Retrieve data from local storage
    const lightboxData = JSON.parse(local.getItem(storageKey));
    const now = Date.now();

    let shouldShowLightbox = false;

    if (!lightboxData || lightboxData.version !== currentSiteVersion) {
        shouldShowLightbox = true;
    } else if (now - lightboxData.timestamp > timeinMs) {
        shouldShowLightbox = true;
    }

	//Displaying logic
    if (shouldShowLightbox) {
		// console.log("LightBox Displayed on " + new Date().toLocaleString())
        wixWindowFrontend.openLightbox(lightboxName).then(() => {
            local.setItem(storageKey, JSON.stringify({
                version: currentSiteVersion,
                timestamp: now
            }));
        });
    }
}

$w.onReady(() => {
	footerLazyLoading();

	if(isEnabled){
    	handleLightbox();
	}
});


async function footerLazyLoading(){
        $w("#footerSection").delete();

	 	await new Promise(resolve => setTimeout(resolve, 2000));
        $w("#footerSection").restore();
}